var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#BEBEBE",
  d: "M16.525 1.082a.5.5 0 0 1 .95 0l3.315 10.201a1.5 1.5 0 0 0 1.427 1.037h10.726a.5.5 0 0 1 .294.904L24.56 19.53a1.5 1.5 0 0 0-.545 1.677l3.315 10.202a.5.5 0 0 1-.77.559l-8.677-6.305a1.5 1.5 0 0 0-1.764 0L7.44 31.967a.5.5 0 0 1-.77-.56l3.316-10.2a1.5 1.5 0 0 0-.545-1.678L.763 13.224a.5.5 0 0 1 .294-.904h10.726a1.5 1.5 0 0 0 1.427-1.037z"
})));
export default SvgStar12;